import { useEffect, useState } from "react";
import { PREVIEW_PROTOCOL } from "./previewProtocolConstants";

export const getPreviewIdentity = () => {
  const requested = new URLSearchParams(window.location.search).get("preview_identity");
  return Object.values(PREVIEW_PROTOCOL.identities).includes(requested)
    ? requested
    : PREVIEW_PROTOCOL.identities.newPatient;
};

export const isExistingPatientPreview = () =>
  getPreviewIdentity() === PREVIEW_PROTOCOL.identities.existingPatient;

export const usePreviewIdentity = () => {
  const [state, setState] = useState(() => ({
    identity: getPreviewIdentity(),
    requestId: null,
    receivedAt: null,
  }));
  useEffect(() => {
    const update = (event) => setState({
      identity: getPreviewIdentity(),
      requestId: event.detail?.requestId || null,
      receivedAt: event.detail?.receivedAt || null,
    });
    window.addEventListener(PREVIEW_PROTOCOL.events.identityChanged, update);
    return () => {
      window.removeEventListener(PREVIEW_PROTOCOL.events.identityChanged, update);
    };
  }, []);
  return state;
};
